import { ReactElement } from 'react';

import { CiGrid2H } from 'react-icons/ci';
import { LuGrid2X2 } from 'react-icons/lu';

import { TToggleView } from '@src/types';

import styles from './viewToggle.module.scss';

interface IviewToggleProps {
  view: TToggleView;
  setView: (v: TToggleView) => void;
}
const views: { name: TToggleView; icon: ReactElement }[] = [
  { name: 'list', icon: <CiGrid2H size={22} /> },
  { name: 'grid', icon: <LuGrid2X2 size={20} /> },
];
const ViewToggle = ({ view, setView }: IviewToggleProps) => {
  return (
    <div className={styles['view-toggle']}>
      {views.map(({ name, icon }) => (
        <button
          id={`view-toggle-${name}`}
          className={`${styles['toggle-btn']} ${view === name ? `${styles['active']}` : ''}`}
          onClick={() => setView(name)}
        >
          {icon}
        </button>
      ))}
    </div>
  );
};

export default ViewToggle;
